import { useNavigation } from "@react-navigation/native";
import React from "react";
import { ScrollView, StyleSheet } from "react-native";
import GenericHeader from "../../components/headers/GenericHeader";
import Colors from "../../constants/Colors";
import { BalanceDetailsCard } from "./BalanceDetailsCard";
import { BalanceLogCard } from "./BalanceLogCard";

export const BalanceScreen = () => {
  const navigation = useNavigation();
  return (
    <>
      <GenericHeader
        title="Balance"
        backAction={() => navigation.navigate("Settings")}
      />
      <ScrollView contentContainerStyle={styles.container}>
        {navigation.isFocused() && (
          <>
            <BalanceDetailsCard />
            <BalanceLogCard />
          </>
        )}
      </ScrollView>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    paddingTop: 16,
    paddingBottom: 100,
    paddingHorizontal: 16,
    backgroundColor: Colors.whiteColor,
  },
});
